const config = require('config');

export const ENVIRONMENTS = Object.freeze({
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
  STAGING: 'staging',
});

export const SITE_DOMAINS = Object.freeze({
  SPORT: 'sport',
  ENTERTAINMENT: 'spettacolo',
  NEWS: 'tg24', // TODO: MOVE TO 'news' for rebranding!!!
});

export const SITE_NAMES = Object.freeze({
  SPORT: 'sport',
  ENTERTAINMENT: 'entertainment',
  NEWS: 'tg24', // TODO: MOVE TO 'news' for rebranding!!!
});

export const SITE_PREFIXES = Object.freeze({
  SPORT: 'skysport',
  NEWS: 'skytg24',
});

export const SKY_FOUNDATION_STATIC_DOMAIN = config.skyFoundationDefaultSettings.staticDomain;
export const SKY_FOUNDATION_VIDEO_PLAYLIST_BASE_URL = config.skyFoundationDefaultSettings.videoPlaylistBaseUrl;
export const SKY_FOUNDATION_PARSELY_API_KEY = config.skyFoundationDefaultSettings.parselyApiKey;
export const SHARE_ON_FACEBOOK_APP_ID = config.skyFoundationDefaultSettings.shareOnFacebookAppId;

const LOCAL_NAV_HEIGHT_MOBILE = 64;
const LOCAL_NAV_HEIGHT_DESKTOP = 67;

export const RESPONSIVE_OFFSETS = {
  default: {
    mobile: LOCAL_NAV_HEIGHT_MOBILE,
    desktop: LOCAL_NAV_HEIGHT_DESKTOP,
  },
};
